module.exports = __webpack_public_path__ + "static/media/master.3ce48bc3.png";